/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_424b6f25"]'><div :class='["dialog-prompt-demo"]'><cube-button @_click="onClickDialog">Dialog - prompt</cube-button><cube-dialog ref="__mpx_ref_dialogPrompt__" type="prompt" :prompt="(promptData)" title="我是标题" cancel-btn="取消" confirm-btn="确认"></cube-dialog></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_424b6f25"}'>
.dialog-btn-content
  text-align center
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_424b6f25"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_424b6f25"}
  /** script content **/
  require("./dialog-prompt.mpx.js?isComponent&outputPath=components%2Fdialog-prompt424b6f25%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-prompt.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-prompt424b6f25%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_424b6f25"],
    ctorType: "component",
    outputPath: "components/dialog-prompt424b6f25/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>